import { useReducer } from "react";

export const INPUT_CHANGED = "INPUT_CHANGED";
export const RESET = "RESET";

const useFormState = (initialState = {}) => {
  const reducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
      case INPUT_CHANGED:
        return {
          ...state,
          ...payload,
        };
      case RESET:
        return initialState;
      default:
        return state;
    }
  };

  return useReducer(reducer, initialState);
};

export const hasChanges = state => Object.keys(state).length > 0;

export const onChangeField = (dispatch, callback) => field => value => {
  if (callback) {
    callback(field, value);
  }
  dispatch({ type: INPUT_CHANGED, payload: { [`${field}`]: value } });
};

export const onClearForm = (dispatch, callback) => {
  if (callback) {
    callback();
  }
  dispatch({ type: RESET });
};

export default useFormState;
